var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 .992H2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-16a2 2 0 0 0-2-2zm0 6a4.25 4.25 0 0 1-3.9-4H30v4zm0 1.62v4.83a5.87 5.87 0 0 0-5.51 5.55h-17A5.87 5.87 0 0 0 2 13.432v-4.84a5.87 5.87 0 0 0 5.51-5.6h17a5.87 5.87 0 0 0 5.49 5.6v.02zM5.9 2.992a4.25 4.25 0 0 1-3.9 4v-4h3.9zM2 15.052a4.25 4.25 0 0 1 3.9 3.94H2v-3.94zm24.1 3.94a4.25 4.25 0 0 1 3.9-3.94v3.94h-3.9z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.842c-3.47 0-6.3 3.21-6.3 7.15 0 3.94 2.83 7.15 6.3 7.15 3.47 0 6.3-3.21 6.3-7.15 0-3.94-2.83-7.15-6.3-7.15zm0 12.69c-2.59 0-4.7-2.49-4.7-5.55 0-3.06 2.11-5.55 4.7-5.55 2.59 0 4.7 2.49 4.7 5.55 0 3.06-2.11 5.56-4.7 5.56v-.01z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.222d8f5e24049cc40f2cb2ee35ac763b.svg";
export { ForwardRef as ReactComponent };